var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-button',{staticClass:"btn btn-outline btn-primary",attrs:{"icon":"view-solid","status":_vm.status},on:{"click":_vm.handleClick}},[_vm._v("Tout marquer comme lu")])
}
var staticRenderFns = []

export { render, staticRenderFns }